const MBTI_INFO = {
    ISTJ: {
        type: "세심한 관리자",
        content: "책임감이 강하고 조직적이에요. 계획을 세우고 체계적으로 일을 처리하는 것을 좋아해요. 신뢰할 수 있고 실용적인 접근 방식을 가지고 있어요."
    },
    ISFJ: {
        type: "다정한 수호자",
        content: "친절하고 헌신적이에요. 다른 사람들을 돕고 배려하는 것을 좋아해요. 세부 사항을 잘 기억하고, 책임감이 강해요."
    },
    INFJ: {
        type: "통찰력 있는 조언자",
        content: "깊은 통찰력과 강한 직관력을 가지고 있어요. 다른 사람들을 이해하고 돕는 것을 중요하게 생각해요. 이상주의적이고 목표 지향적이에요."
    },
    INTJ: {
        type: "전략적인 계획가",
        content: "독립적이고 분석적이에요. 문제를 해결하고 목표를 달성하는 데 집중해요. 장기적인 계획을 세우고 전략적으로 접근해요."
    },
    ISTP: {
        type: "냉철한 분석가",
        content: "실용적이고 논리적이에요. 문제를 해결하고 새로운 도전을 즐겨요. 독립적이며 즉흥적인 행동을 잘해요."
    },
    ISFP: {
        type: "호기심 많은 예술가",
        content: "예술적이고 감각적인 것을 좋아해요. 자유롭고 유연한 생활 방식을 선호해요. 따뜻하고 친절하며 다른 사람들을 배려해요."
    },
    INFP: {
        type: "열정적인 중재자",
        content: "이상주의적이고 감성적이에요. 자신의 가치와 신념을 중요하게 생각해요. 다른 사람들을 돕고 세상을 더 나은 곳으로 만들고자 해요."
    },
    INTP: {
        type: "논리적인 사색가",
        content: "호기심이 많고 논리적이에요. 복잡한 문제를 해결하고 새로운 아이디어를 탐구하는 것을 좋아해요. 독립적이며 깊이 있는 사고를 해요."
    },
    ESTP: {
        type: "활동적인 해결사",
        content: "활동적이고 현실적인 성격이에요. 새로운 도전을 즐기고 문제를 빠르게 해결해요. 사교적이며 즉각적인 결정을 잘 내려요."
    },
    ESFP: {
        type: "사교적인 연예인",
        content: "활발하고 사교적이에요. 사람들과 어울리는 것을 좋아하고, 현재 순간을 즐기는 경향이 있어요. 감각적인 경험을 중요하게 생각해요."
    },
    ENFP: {
        type: "열정적인 활동가",
        content: "창의적이고 열정적이에요. 새로운 아이디어와 가능성에 열려 있어요. 사람들과의 관계를 중요하게 여기고, 동기 부여를 잘해요."
    },
    ENTP: {
        type: "재기발랄한 발명가",
        content: "재치 있고 논리적이에요. 새로운 아이디어를 탐구하고, 논쟁을 즐겨요. 문제 해결을 위한 창의적인 접근을 선호해요."
    },
    ESTJ: {
        type: "실용적인 관리자",
        content: "조직적이고 실용적이에요. 규칙과 질서를 중시하며, 계획을 세워 일을 효과적으로 처리해요. 책임감이 강하고, 리더십을 발휘해요."
    },
    ESFJ: {
        type: "배려하는 제공자",
        content: "사교적이고 친절해요. 다른 사람들을 돕고 배려하는 것을 중요하게 생각해요. 조직적이고 실용적인 접근 방식을 가지고 있어요."
    },
    ENFJ: {
        type: "카리스마 있는 지도자",
        content: "카리스마 있고 사교적이에요. 다른 사람들을 이해하고 동기를 부여하는 데 능해요. 타인의 감정과 필요를 잘 파악해요."
    },
    ENTJ: {
        type: "결단력 있는 지도자",
        content: "결단력 있고 목표 지향적이에요. 논리적이고 체계적으로 문제를 해결해요. 리더십을 발휘하며, 장기적인 목표를 설정하고 달성해요."
    }
    };

export default MBTI_INFO;
